import * as ECAPI from './EcommerceService.ts';
import type { PromotionContent, PromotionGroup } from '@/domain/Promotion.ts';
import { fromEcapiDto } from '@/domain/assemblers/PromotionAssembler.ts';

export async function getPromotions(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<PromotionGroup[]> {
  const promotionsContent = await ECAPI.cms(
    market,
    channel,
    'catalog_promotions',
    locale,
    cacheBurst
  );
  const promos: PromotionContent['promotionGroups'] =
    ((promotionsContent.payload ?? {}) as PromotionContent)?.promotionGroups ??
    [];
  return fromEcapiDto(promos);
}
